import { useColorMode } from "../../hooks/useColorMode";
import { useSignInState } from "./hooks/useSignInState";
import { SignInErrorOrLogout } from "./SignInErrorOrLogout";

export function SignIn() {
  useColorMode({ bindListeners: true });

  const { signInState, error, checkAndRedirect } = useSignInState();

  // Auth is always SSO: a configured provider redirects straight to the IdP, so
  // the page only renders to show an error or a manual "sign in" action that
  // re-triggers the SSO redirect.
  if (signInState === "redirecting") return null;
  return (
    <SignInErrorOrLogout error={error} onPrimaryAction={checkAndRedirect} />
  );
}
